import { lazy, Suspense, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import './assets/css/Responisve.css'
// import "../src/assets/css/Front.css"
import ThemeRoutes from "./admin/routes/ThemeRoutes";
import ThemeCustomization from './admin/themes/index';
import { Provider } from "react-redux";
import { store } from "./app/store";

const Chatbot = lazy(() => import("../src/front/components/chatbox/ChatBox"));
const WhatsAppFloat = lazy(() => import("./front/components/whatsapp/WhatsAppFloat"));

function App() {
  useEffect(() => {
    const timer = setTimeout(() => {
      AOS.init();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  // Chatbot & WhatsApp float should only show on the public/front website,
  // never inside the admin panel (any route starting with /admin)
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    const time = 18000000
    const timer = setTimeout(() => {
      localStorage.clear();
      navigate("/login");
    }, time);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <ThemeCustomization>
      <Provider store={store}>
        <ThemeRoutes />
        {!isAdminRoute && (
          <Suspense fallback={null}>
            <Chatbot />
            <WhatsAppFloat />
          </Suspense>
        )}
      </Provider>
      <ToastContainer />
    </ThemeCustomization>
  );
}

export default App;
